import { render, staticRenderFns } from "./AlipayReturn.vue?vue&type=template&id=6782d105"
import script from "./AlipayReturn.vue?vue&type=script&lang=js"
export * from "./AlipayReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports